// extracted by mini-css-extract-plugin
module.exports = {"profile":"bazaar-profile-pure-view-profile_profile__3Y_j2"};